/**
 * Quiz dopasowania rasy — /quiz-rasy/.
 *
 * Klucz mechaniki: „Nieistotne" USUWA wymiar z obliczenia. W odpowiedziach
 * pomijamy klucz całkowicie zamiast wysyłać 0 albo wartość środkową — backend
 * liczy karę tylko dla wymiarów, które dostał.
 */
export function initBreedQuiz() {
    const root = document.querySelector('[data-hn-breed-quiz]');
    if (!root) return;

    const steps = [...root.querySelectorAll('[data-hn-bq-step]')];
    const total = steps.length;
    const bar = root.querySelector('[data-hn-bq-progress]');
    const barTxt = root.querySelector('[data-hn-bq-progress-text]');
    const stepsWrap = root.querySelector('[data-hn-bq-steps]');
    const results = root.querySelector('[data-hn-bq-results]');
    const grid = root.querySelector('[data-hn-bq-results-grid]');
    const empty = root.querySelector('[data-hn-bq-results-empty]');
    const lead = root.querySelector('[data-hn-bq-results-lead]');

    const answers = {};
    let idx = 0;

    const track = (event, extra) => {
        if (window.dataLayer) window.dataLayer.push(Object.assign({ event }, extra || {}));
    };

    const render = () => {
        steps.forEach((s, i) => { s.hidden = i !== idx; });
        if (bar) bar.style.width = Math.round((idx / total) * 100) + '%';
        if (barTxt) barTxt.textContent = (idx + 1) + '/' + total;
    };

    const advance = () => {
        if (idx < total - 1) { idx++; render(); return; }
        submit();
    };

    // Pojedynczy wybór → od razu dalej. Wielokrotny → czeka na „Dalej".
    root.querySelectorAll('[data-hn-bq-options]').forEach((box) => {
        const key = box.dataset.key;
        const multi = box.dataset.multi === '1';

        box.querySelectorAll('[data-hn-bq-option]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const val = btn.dataset.value;
                if (multi) {
                    btn.classList.toggle('is-active');
                    const picked = [...box.querySelectorAll('.is-active')].map((b) => b.dataset.value);
                    if (picked.length) answers[key] = picked; else delete answers[key];
                    return;
                }
                box.querySelectorAll('[data-hn-bq-option]').forEach((b) => b.classList.remove('is-active'));
                btn.classList.add('is-active');
                if (key === 'alergia') answers.alergia = val === '2';
                else answers[key] = parseInt(val, 10);
                advance();
            });
        });

        // „Dalej" dla pytania wielokrotnego — dokładany tylko tam, gdzie potrzebny.
        if (multi) {
            const nav = box.parentElement.querySelector('[data-hn-bq-nav], .hn-quiz__nav');
            if (nav) {
                const next = document.createElement('button');
                next.type = 'button';
                next.className = 'hn-btn hn-btn--primary';
                next.textContent = 'Dalej';
                next.addEventListener('click', advance);
                nav.prepend(next);
            }
        }
    });

    root.querySelectorAll('[data-hn-bq-skip]').forEach((btn) => {
        btn.addEventListener('click', () => {
            // Świadomie NIE zapisujemy nic — brak klucza = wymiar pominięty.
            advance();
        });
    });

    root.querySelectorAll('[data-hn-bq-back]').forEach((btn) => {
        btn.addEventListener('click', () => { if (idx > 0) { idx--; render(); } });
    });

    /**
     * rest_url() i adresy mediów zwracają kanoniczny adres witryny. Gdy strona jest
     * otwarta pod innym protokołem lub hostem (lokalny http przy home_url na https,
     * podgląd na stagingu), fetch pada na CORS, a obrazki na mixed content.
     * Sprowadzamy oba do bieżącego origin.
     */
    const sameOrigin = (url) => {
        try {
            const u = new URL(url, window.location.href);
            return u.origin === window.location.origin ? u.href : u.pathname + u.search;
        } catch (e) { return url; }
    };

    // Treść pochodzi z REST (dane z bazy), ale i tak escapujemy — kafel wstawiamy
    // przez innerHTML, więc nazwa rasy z tytułu wpisu nie może wnieść znaczników.
    const esc = (s) => String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    const card = (b) => {
        const powody = (b.powody || []).map((p) => '<li>' + esc(p) + '</li>').join('');
        const ostrz = (b.ostrzezenia || []).map((o) => '<p class="hn-bq-card__warn">' + esc(o) + '</p>').join('');
        const foto = b.obraz
            ? '<a class="hn-bq-card__media" href="' + esc(sameOrigin(b.url)) + '">'
              + '<img src="' + esc(sameOrigin(b.obraz)) + '" alt="' + esc(b.obraz_alt || b.nazwa) + '" loading="lazy" width="480" height="320">'
              + '</a>'
            : '';
        const cta = b.ma_artykul ? 'Przeczytaj o rasie' : 'Zobacz rasę';
        return '<article class="hn-bq-card">'
            + foto
            + '<div class="hn-bq-card__score">' + esc(b.score) + '% dopasowania</div>'
            + '<h3 class="hn-bq-card__name"><a href="' + esc(sameOrigin(b.url)) + '">' + esc(b.nazwa) + '</a></h3>'
            + '<p class="hn-bq-card__size">Rozmiar: ' + esc(b.rozmiar) + '</p>'
            + (powody ? '<ul class="hn-bq-card__reasons">' + powody + '</ul>' : '')
            + ostrz
            + '<a class="hn-btn hn-btn--primary hn-bq-card__cta" href="' + esc(sameOrigin(b.url)) + '">' + cta + '</a>'
            + '</article>';
    };

    async function submit() {
        const endpoint = sameOrigin((window.hnBreedQuiz && window.hnBreedQuiz.endpoint) || '/wp-json/hn/v1/breed-match');
        track('hn_breed_quiz_submit', { odpowiedzi: Object.keys(answers).length, z: total });
        try {
            const resp = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(answers),
            });
            const data = await resp.json();
            const list = data.results || [];
            stepsWrap.hidden = true;
            results.hidden = false;
            if (bar) bar.style.width = '100%';
            if (barTxt) barTxt.textContent = total + '/' + total;

            // Zero odpowiedzi = brak podstaw do dopasowania. Backend zwraca wtedy
            // pustą listę z komunikatem, zamiast udawać, że coś policzył.
            if (!list.length) {
                empty.hidden = false;
                if (data.komunikat) {
                    const p = empty.querySelector('p');
                    if (p) p.textContent = data.komunikat;
                }
                return;
            }

            grid.innerHTML = list.map(card).join('');
            if (lead) {
                // Ile pytań realnie wypełniono. Bez tego "99% dopasowania" po dwóch
                // odpowiedziach wygląda na pewność, której nie ma.
                const w = data.wymiary || 0;
                lead.textContent = 'Wynik oparty na ' + w + ' z ' + total
                    + ' pytań, spośród ' + data.total + ' opisywanych przez nas ras.'
                    + (w < 5 ? ' Odpowiedz na więcej pytań, a dopasowanie będzie dokładniejsze.' : '');
            }
            track('hn_breed_quiz_result', { top: list[0] ? list[0].slug : '', pula: data.total });
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (err) {
            track('hn_breed_quiz_error', { message: String((err && err.message) || err).slice(0, 120) });
            stepsWrap.hidden = true;
            results.hidden = false;
            empty.hidden = false;
        }
    }

    const restart = root.querySelector('[data-hn-bq-restart]');
    if (restart) {
        restart.addEventListener('click', () => {
            Object.keys(answers).forEach((k) => delete answers[k]);
            root.querySelectorAll('.is-active').forEach((b) => b.classList.remove('is-active'));
            results.hidden = true;
            stepsWrap.hidden = false;
            idx = 0;
            render();
        });
    }

    track('hn_breed_quiz_start');
    render();
}
